<template>
  <div class="nav" :style="{ width: navStatusWidth }">
    <div class="changeNavStatus" @click="changeNavStatus">
      <el-icon v-if="navStatus"><Expand /></el-icon>
      <el-icon v-else><Fold /></el-icon>
    </div>
    <el-tooltip
      class="box-item"
      effect="dark"
      :content="'LuckyWin-' + $t('navComponent.title')"
      placement="bottom"
      v-if="!navStatus"
    >
      <p class="title" @click="selectHome">
        LuckyWin-{{ $t("navComponent.title") }}
      </p>
    </el-tooltip>
    <p class="platfor" v-if="!navStatus">
      {{ store.state.userInfo ? store.state.userInfo.platformName : "" }}({{
        store.state.userInfo ? store.state.userInfo.platformCode : ""
      }})
    </p>
    <div style="overflow-y: scroll; height: 100%" class="nav-box">
      <el-menu
        :default-active="store.state.navValue"
        :collapse="navStatus"
        :unique-opened="true"
        @select="navSelect"
        class="menu"
      >
        <template v-for="(item, index) in navList">
          <el-sub-menu
            :index="item.index"
            v-if="!item.isHide && item.child && item.child.length > 0"
            :key="index"
          >
            <template #title>
              <el-icon><component :is="item.source" /></el-icon>
              <span>{{ item.name }}</span>
            </template>
            <template v-for="(item2, index2) in item.child">
              <el-sub-menu
                :index="item2.index"
                v-if="
                  item2.child &&
                  item2.child.length > 0 &&
                  item2.child[0]['category'] == '1'
                "
                :key="index2"
              >
                <template #title>
                  <el-icon><component :is="item2.source" /></el-icon>
                  <!-- <span>{{ item2.name }}</span> -->
                  <span
                    v-if="
                      store.state.lang == 'zh' ||
                      (store.state.lang == 'vn' && item2.name.length < 18)
                    "
                    >{{ item2.name }}</span
                  >
                  <el-tooltip
                    effect="dark"
                    :content="item2.name"
                    placement="right"
                    v-else
                  >
                    <p>
                      {{ item2.name }}
                    </p>
                  </el-tooltip>
                </template>
                <el-menu-item
                  :index="index + '-' + index2 + '-' + index3"
                  v-for="(item3, index3) in item2.child"
                  :key="index3"
                >
                  <el-icon><component :is="item3.source" /></el-icon>
                  <!-- {{ item3.name }} -->
                  <span
                    v-if="
                      store.state.lang == 'zh' ||
                      (store.state.lang == 'vn' && item3.name.length < 15)
                    "
                    >{{ item3.name }}</span
                  >
                  <el-tooltip
                    effect="dark"
                    :content="item3.name"
                    placement="right"
                    v-else
                  >
                    <p>
                      {{ item3.name }}
                    </p>
                  </el-tooltip>
                </el-menu-item>
              </el-sub-menu>
              <template v-else>
                <el-menu-item :index="item2.index" :key="index2">
                  <el-icon><component :is="item2.source" /></el-icon>
                  <!-- <span>{{ item2.name }}</span> -->
                  <span
                    v-if="
                      store.state.lang == 'zh' ||
                      (store.state.lang == 'vn' && item2.name.length < 20)
                    "
                    >{{ item2.name }}</span
                  >
                  <el-tooltip
                    effect="dark"
                    :content="item2.name"
                    placement="right"
                    v-else
                  >
                    <p>
                      {{ item2.name }}
                    </p>
                  </el-tooltip>
                </el-menu-item>
              </template>
            </template>
          </el-sub-menu>
          <template v-else>
            <el-menu-item v-if="!item.isHide" :index="item.index" :key="index">
              <el-icon><component :is="item.source" /></el-icon>
              <span>{{ item.name }}</span>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { ChatLineRound, Connection } from "@element-plus/icons-vue";
export default {
  props: {
    navStatus: "",
    navList: null,
  },
  components: {
    ChatLineRound,
    Connection,
  },
  setup(props, { emit }) {
    const navStatusWidth = ref("220px");
    const store = useStore();
    const navSelect = (index) => {
      emit("navSelect", index);
    };
    const changeNavStatus = () => {
      emit("changeNavStatus");
      if (props.navStatus) {
        setTimeout(() => {
          navStatusWidth.value = "220px";
        }, 150);
      } else {
        navStatusWidth.value = "auto";
      }
    };
    const selectHome = () => {
      emit("selectHome");
    };
    return {
      store,
      navStatusWidth,
      selectHome,
      navSelect,
      changeNavStatus,
    };
  },
};
</script>
<style lang="scss" scoped>
.nav {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  padding-top: 65px;
  background: #20222a;
  z-index: 11;
  .menu {
    overflow: hidden;
  }
  .nav-box {
    overflow-y: scroll;
    height: 100%;
    :deep(.el-sub-menu) {
      //width: 90%;
      overflow: hidden;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    :deep(.el-sub-menu .el-sub-menu__icon-arrow) {
      right: 10px;
    }
    :deep(.el-tooltip__trigger) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.nav-box::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.nav-box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #000;
}
.title {
  position: absolute;
  cursor: pointer;
  color: #c8aa8c;
  z-index: 2;
  left: 0px;
  top: 0px;
  width: 220px;
  text-align: center;
  font-size: 18px;
  height: 26px;
  overflow: hidden;
}
.platfor {
  position: absolute;
  z-index: 2;
  text-align: center;
  width: 220px;
  font-size: 14px;
  left: 0px;
  top: 30px;
  color: #c8aa8c;
}
.changeNavStatus {
  position: absolute;
  cursor: pointer;
  color: #c8aa8c;
  z-index: 2;
  right: -30px;
  top: 20px;
  font-size: 20px;
}
</style>
